export enum RolePermissions {
  MASTER = 15,
}

export enum UserPermission {
  USER_MASTER_NEC_ANTIGO = 2,
  USER_MASTER_NEC = 17,
}
